'use client'
import { cn } from '@/core/lib/utils/cn'
import { formatPrice } from '@/core/lib/utils/format-price'
import { useAuth } from '@/core/store/auth'
import { RemoteImage } from '@/core/ui/atoms/remote-image'
import { Product } from '@/features/product/model/product.model'
import { Card, CardBody, CardFooter } from '@heroui/react'
import { Heart, Star } from 'lucide-react'
import { useLocale } from 'next-intl'
import Link from 'next/link'
import { useToggleFav } from '../../hooks/use-toggle-fav'

export function ProductCard({
  name,
  rating,
  slug,
  cover,
  // attribute,
  is_favorite,
  best_seller,
  currency_symbol,
  price,
}: Product) {
  const { isFav, toggle } = useToggleFav(is_favorite, slug)
  // const price = attribute?.find(attr => attr.id == BASE_ATTRIBUTES.price)?.value

  const shortDesc = name.length > 100 ? name.slice(0, 100) + '...' : name
  const { isAuthenticated } = useAuth()
  const locale = useLocale()

  return (
    <Link href={`/products/${slug}`}>
      <Card className='w-full rounded-md shadow-md transition hover:shadow-lg'>
        <div className='relative h-32 w-full'>
          <RemoteImage
            src={cover?.preview_url}
            alt={name}
            fill
            className='rounded-md object-fill p-1'
          />
          {isAuthenticated && (
            <button
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                toggle()
              }}
              className='absolute top-3 right-3 cursor-pointer rounded-full bg-white p-2 shadow hover:bg-gray-100'
            >
              <Heart
                className={cn(
                  'h-4 w-4 transition-colors duration-300',
                  isFav ? 'text-creamed-cron fill-creamed-cron' : 'text-black',
                )}
              />
            </button>
          )}
        </div>
        <CardBody className={cn('p-1.5 pb-0', locale === 'ar' && 'text-right')}>
          <p className='text-mountain-bluebird h-14 overflow-hidden text-sm break-words'>
            {shortDesc}
          </p>

          <p className='text-md text-mountain-bluebird mt-0.5 font-semibold'>
            {formatPrice(price, currency_symbol)}
          </p>
        </CardBody>
        <CardFooter className='flex items-center justify-between p-1 pt-0'>
          <div className='flex items-center'>
            <Star className='fill-creamed-cron text-creamed-cron me-1 h-4 w-4' />
            <span className='text-mountain-bluebird font-bold'>{rating}</span>
          </div>

          {best_seller == '1' && (
            <span className='text-saffron rounded bg-[#F5B22F33] px-1 text-sm leading-[17px]'>
              Best seller
            </span>
          )}
        </CardFooter>
      </Card>
    </Link>
  )
}
